import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Tema tercihi (karanlık mod) — render'dan ÖNCE uygula ki flash olmasın
try {
  if (localStorage.getItem("cd_theme") === "dark") {
    document.documentElement.classList.add("dark");
  }
} catch (e) {}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
